import {FC} from 'react';
import SearchIcon from '@mui/icons-material/Search';
import {Search, SearchIconWrapper, StyledInputBase} from "../../_style/searchInputStyle";
import {useNavigate} from "react-router-dom";

const ResearchInput: FC<{}> = () => {
    const navigate = useNavigate()

    const handleChange = (e:any) => {
        navigate(`/research/${e.target.value}`)
    }


    return (
        <Search>
            <SearchIconWrapper>
                <SearchIcon color="primary"/>
            </SearchIconWrapper>
            <StyledInputBase
                placeholder="Search…"
                inputProps={{'aria-label': 'search'}}
                onChange={(e) => handleChange(e)}
            />
        </Search>
    );
};

export default ResearchInput;
